import {
  IContent,
  IContentReference,
  IEvent,
  IExternalClient,
  IFacility,
  ILeadLookupConfig,
  ILeadLookupValue,
  IMedia,
  IModel,
  IPrompt,
  IRegistrationConsent,
  ITemplate,
  ITool,
  ITrait,
  IUser,
  IWorkspace,
  IWorkspaceSubscription,
  Lead,
  LeadSession,
  SessionMetric,
  SessionTrait,
  SmartProperty,
} from '..'

export interface Collection {
  content: IContent
  contentReferences: IContentReference
  events: IEvent
  externalClients: IExternalClient
  facilities: IFacility
  leadLookupConfig: ILeadLookupConfig
  leadLookupValues: ILeadLookupValue
  Media: IMedia
  Model: IModel
  prompts: IPrompt
  registrationConsents: IRegistrationConsent
  templates: ITemplate
  tools: ITool
  traits2: ITrait
  users: IUser
  Workspace: IWorkspace
  workspaceSubscriptions: IWorkspaceSubscription
}

export interface DCTable {
  leads: Omit<Lead, 'smartProperties'> & WorkspaceAndEvent & DBProps
  leadSessions: Omit<LeadSession, 'traits' | 'metrics'> &
    WorkspaceAndEvent &
    DBProps & { leadId?: string }
  sessionTraits: SessionTrait & WorkspaceAndEvent & DBProps & { sessionId: string }
  sessionMetrics: SessionMetric & WorkspaceAndEvent & DBProps & { sessionId: string }
  smartProperties: SmartProperty & WorkspaceAndEvent & DBProps & { leadId: string }
}

export type DCTableName = keyof DCTable

export type CollectionName = keyof Collection

export interface WorkspaceAndEvent {
  eventId: string
  workspaceId: string
}

export type MultiLanguageString = MultiLanguage<string>
export type Language = keyof MultiLanguage<unknown>

export interface MultiLanguage<T> {
  en: T
  es?: T
  fr?: T
  pt?: T
}

export interface Location {
  city: string
  /** 2-digit ISO country code */
  country: string
  /** 2-digit ISO state code */
  state?: string
  lat: number
  lng: number
  timezone: string
}

export type OmitDBProps<T> = Omit<T, keyof DBProps>

export interface DBProps {
  readonly id: string
  /** UTC timestamp */
  readonly created: number | string
  readonly createdBy: string
  /** UTC timestamp */
  readonly updated: number | string
  readonly updatedBy: string
}

export type ScalarValue = string | number | boolean

export const dbProps: (keyof DBProps)[] = ['id', 'created', 'createdBy', 'updated', 'updatedBy']

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] }

export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object | undefined
      ? RecursivePartial<T[P]>
      : T[P]
}
